/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Alert type
 */
export type SetAlertThresholdRequestAlertType = typeof SetAlertThresholdRequestAlertType[keyof typeof SetAlertThresholdRequestAlertType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetAlertThresholdRequestAlertType = {
  PERCENT: 'PERCENT',
  VALUE: 'VALUE',
} as const;
